/**
 * @module geo/components
 *
 */


import {fromPromise} from 'rxjs/observable/fromPromise';

import {registerExtensionCreatorP} from '../actions/creators/register.extension.creator';
import {REGISTER_EXTENSION} from '../payload/facade';
import {Extension, ExtensionProperties, ExtensionType} from '../types/extensions';
import {ThematicsEntriesExtensionProperties} from '../types/extensions/thematic.entries';

import {Component} from './component';

/**
 * Show and handle way of switching  layers.
 * @since v2.0.1
 */
export class LayerControl extends Component {
  public buildExtension(properties: ExtensionProperties): Extension {
    const type = ExtensionType.THEMATICS;
    return {type, properties} as Extension;
  }

  public addEntryExtension(extensionProperties:
                               ThematicsEntriesExtensionProperties) {
    if (!this.store) {
      throw new Error('No store defined');
    }

    const props: ThematicsEntriesExtensionProperties = {
      key: 'geoapi.thematic.entry',
      icon: 'icon',
      enable: () => true,
      handle: () => {}
    };
    Object.assign(props, extensionProperties);
    const extension = new REGISTER_EXTENSION(ExtensionType.THEMATICS, props);
   
    return fromPromise(
        registerExtensionCreatorP(extension, this.store.dispatch));
  }
}
